define('components/course/models/slide-type/survey',[
    "components/course/models/slide-type/zeus-base"
], function(BaseModel) {
    "use strict";

    var SurveyModel = BaseModel.extend({

        "defaults": function() {
            var baseDefaults = BaseModel.prototype.defaults.call(this),
                defaults = {
                    "isComplete": 0, // State if slide completed by user for submit button at last. Default - 0
                    "type": "survey",
                    "data": {}
                };
            return _.extend(baseDefaults, defaults);
        },

        "initialize": function() {
            this._populateData();
        },

        "authoringJSONKey": function() {
            return _.extend(BaseModel.prototype.authoringJSONKey.call(this), {
                "data": {
                    "slidesMapping": null,
                    "maxScore": null,
                    "scoreFeedbacks": null,
                    "globalComponentData": null,
                    "isAccTitleTextSame": false,
                    "isAccContentTextSame": false,
                    "accTitleText": null,
                    "accContentText": null
                }
            });
        },

        "_populateData": function() {
            if (this.get('data') === null) {
                this.set('data', this._getDataJson());
            }
        },

        "_getDataJson": function() {
            return {
                "slidesMapping": [],
                "maxScore": 0,
                "scoreFeedbacks": [{
                    "useRange": false,
                    "specifyAsPercentage": false,
                    "checkingCriteria": {
                        "value_left": SurveyModel.DROP_DOWN_VALUE.WITH_USE_RANGE.LESS_THAN,
                        "value_right": SurveyModel.DROP_DOWN_VALUE.WITHOUT_USE_RANGE.EQUAL_TO
                    },
                    "checkingScore": {
                        "value_left": null,
                        "value_right": null
                    },
                    "title": "",
                    "content": "",
                    "titleUserScoreStatus": [],
                    "contentUserScoreStatus": [],
                    "isAccTitleTextSame": false,
                    "isAccContentTextSame": false,
                    "accTitleText": null,
                    "accContentText": null
                }]
            };
        },

        /**
         * This resets model attribute to defaults
         * @method resetAll
         **/
        "resetAll": function() {
            this.set('data', this._getDataJson());
        }

    }, {
        "DROP_DOWN_VALUE": {
            "WITH_USE_RANGE": {
                "LESS_THAN": "less-than",
                "LESS_THAN_EQUAL_TO": "less-than-equal-to"
            },
            "WITHOUT_USE_RANGE": {
                "EQUAL_TO": "equal-to",
                "LESS_THAN": "less-than",
                "LESS_THAN_EQUAL_TO": "less-than-equal-to",
                "GREATER_THAN": "greater-than",
                "GREATER_THAN_EQUAL_TO": "greater-than-equal-to"
            }
        },

        "USER_SCORE_FIELD_STATUS": {
            "BOLD": 1,
            "ITALIC": 2,
            "UNDERLINE": 4,
            "ALL": 7
        },

        "USER_SCORE_FIELD_TYPE": {
            "TITLE_SCORE_FIELD": "title-score-field",
            "CONTENT_SCORE_FIELD": "content-score-field"
        },

        "USER_SCORE_FIELD_EVENTS": {
            "DELETE": "delete",
            "SETTING_TOOLTIP_SHOWN": "setting-tooltip-shown",
            "HIDE_TOOLTIP": "hide-tootip"
        },

        "USER_SCORE_FIELD_IMAGE_PATH": "media/image/slide-type/survey/user-score-field.png"
    });
    return SurveyModel;
});

